<template>
  <div id="app">
    <nav class="navbar">
      <div class="container">
        <div class="nav-brand">
          <router-link to="/" class="logo-container">
            <div class="logo-combined">
              <img 
                src="/Final_logo.png" 
                alt="Logo"
                class="logo-icon"
              />
              <div class="logo-stack">
                <img 
                  src="/Advanced_text.png" 
                  alt="Advanced"
                  class="nav-logo advanced-logo"
                />
                <img 
                  src="/Innovate_text.png" 
                  alt="Innovate"
                  class="nav-logo innovate-logo"
                />
              </div>
            </div>
          </router-link>
        </div>

        <!-- Mobile menu button -->
        <button class="mobile-menu-button" @click="toggleMenu" :aria-expanded="isMenuOpen">
          <span class="hamburger" :class="{ 'active': isMenuOpen }">
            <span class="hamburger-line"></span>
            <span class="hamburger-line"></span>
            <span class="hamburger-line"></span>
          </span>
        </button>
        
        <!-- Navigation Links -->
        <div class="nav-links" :class="{ 'active': isMenuOpen }">
          <router-link to="/" @click="closeMenu">Home</router-link>
          <router-link to="/services" @click="closeMenu">Services</router-link>
          <router-link to="/products" @click="closeMenu">Products</router-link>
          <router-link to="/about" @click="closeMenu">About</router-link>
          <router-link to="/careers" @click="closeMenu">Careers</router-link>
          <router-link to="/contact" class="contact-btn" @click="closeMenu">Contact</router-link>
        </div>
      </div>
    </nav>
    <router-view/>
  </div>
</template>

<script>
export default {
  name: 'App',
  data() {
    return {
      isMenuOpen: false,
      isMobile: false
    };
  },
  methods: {
    toggleMenu() {
      this.isMenuOpen = !this.isMenuOpen;
      if (this.isMenuOpen) {
        document.body.style.overflow = 'hidden';
        window.addEventListener('scroll', this.closeMenu, { passive: true });
      } else {
        document.body.style.overflow = '';
        window.removeEventListener('scroll', this.closeMenu);
      }
    },
    closeMenu() {
      this.isMenuOpen = false;
      document.body.style.overflow = '';
      window.removeEventListener('scroll', this.closeMenu);
    },
    checkScreenSize() {
      this.isMobile = window.innerWidth <= 991;
      if (!this.isMobile) {
        this.closeMenu();
      }
    },
    handleScroll() {
      if (this.isMenuOpen) {
        this.closeMenu();
      }
    }
  },
  mounted() {
    this.checkScreenSize();
    window.addEventListener('resize', this.checkScreenSize);
    window.addEventListener('scroll', this.handleScroll, { passive: true });
  },
  beforeUnmount() {
    window.removeEventListener('resize', this.checkScreenSize);
    window.removeEventListener('scroll', this.handleScroll);
    window.removeEventListener('scroll', this.closeMenu);
  }
};
</script>

<style>
@import url('https://fonts.googleapis.com/css2?family=Inter:wght@300;400;500;600;700&display=swap');

* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
  font-family: 'Inter', sans-serif;
}

body, html {
  width: 100%;
  overflow-x: hidden;
}

#app {
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  width: 100%;
  overflow-x: hidden;
}

/* Navigation Bar */
.navbar {
  background: white;
  padding: 0.5rem 0;
  position: sticky;
  top: 0;
  z-index: 1000;
  width: 100%;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

.container {
  width: 100%;
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 1.5rem;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

/* Logo */
.logo-combined {
  display: flex;
  align-items: flex-start;
  gap: 0.5rem;
  padding-top: 0.2rem;
}

.logo-icon {
  height: 40px;
  width: auto;
}

.logo-stack {
  display: flex;
  flex-direction: column;
  gap: 0.2rem;
  margin-top: 0.2rem;
}

.advanced-logo { height: 14px; }
.innovate-logo { height: 9px; margin-left: 2.9rem; }

/* -------------------- */
/* HAMBURGER MENU BUTTON */
/* -------------------- */

.mobile-menu-button {
  display: none; /* hidden on desktop */
  background: none;
  border: 2px solid rgba(5, 126, 230, 0.2);
  border-radius: 6px;
  cursor: pointer;
  padding: 0.5rem;
  z-index: 1001;
}

.hamburger {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  width: 24px;
  height: 18px;
}

.hamburger-line {
  width: 100%;
  height: 2px;
  background-color: #057ee6;
  transition: all 0.3s ease;
  border-radius: 2px;
}

.hamburger.active .hamburger-line:nth-child(1) {
  transform: translateY(8px) rotate(45deg);
}
.hamburger.active .hamburger-line:nth-child(2) {
  opacity: 0;
}
.hamburger.active .hamburger-line:nth-child(3) {
  transform: translateY(-8px) rotate(-45deg);
}

/* Navigation Links */
.nav-links {
  display: flex;
  align-items: center;
  gap: 1rem;
  margin-left: auto;
}

.nav-links a {
  color: #057ee6;
  text-decoration: none;
  padding: 0.5rem 0.75rem;
  font-weight: 500;
}

.nav-links .contact-btn {
  background: #057ee6;
  color: white;
  padding: 0.5rem 1rem;
  border-radius: 4px;
}

/* --------------------
   MOBILE (< 991px)
--------------------- */
@media (max-width: 991px) {

  .mobile-menu-button {
    display: flex;
    width: 40px;
    height: 40px;
    align-items: center;
    justify-content: center;
  }

  .nav-links {
    position: fixed;
    top: 60px;
    left: 0;
    right: 0;
    flex-direction: column;
    padding: 0 1rem;
    max-height: 0;
    overflow: hidden;
    visibility: hidden;
    opacity: 0;
    transition: max-height 0.3s ease, opacity 0.3s ease;
    background: white;
    box-shadow: 0 4px 6px rgba(0,0,0,0.1);
  }

  .nav-links.active {
    max-height: 500px;
    opacity: 1;
    visibility: visible;
    padding: 1rem;
  }

  .nav-links a {
    background: rgba(5, 126, 230, 0.05);
    width: 100%;
    border-radius: 4px;
    margin-bottom: 0.3rem;
  }

  .nav-links .contact-btn {
    width: 100%;
  }
}

/* --------------------
   SMALL MOBILE (< 480px)
   → Hide company name
--------------------- */
@media (max-width: 480px) {
  .logo-stack {
    display: none; /* hide company name */
  }

  .logo-icon {
    height: 32px; /* slightly smaller logo */
  }
}

/* Smaller mobile */
@media (max-width: 768px) {
  .logo-icon { height: 30px; }
  .advanced-logo { height: 14px; }
  .innovate-logo { height: 10px; }
}
</style>
